import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';

export default function SaveStatusMessage({ type = 'success', message = '', onClose, autoClose = true }) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (autoClose && isVisible) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                onClose?.();
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [autoClose, isVisible, onClose]);

    if (!isVisible) return null;

    const isSuccess = type === 'success';

    return (
        <div className={`fixed top-6 right-6 px-6 py-4 rounded-lg shadow-2xl flex items-center gap-3 backdrop-blur-sm animate-slideIn z-[9999] ${
            isSuccess 
                ? 'bg-emerald-50 border-2 border-emerald-500' 
                : 'bg-red-50 border-2 border-red-500'
        }`}>
            {isSuccess ? (
                <>
                    <CheckCircleIcon className="w-6 h-6 text-emerald-600 flex-shrink-0" />
                    <div>
                        <p className="font-bold text-emerald-900">Guardado con éxito</p>
                        {message && message !== 'Estrategia guardada correctamente' && (
                            <p className="text-sm text-emerald-700">{message}</p>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <ExclamationCircleIcon className="w-6 h-6 text-red-600 flex-shrink-0" />
                    <div>
                        <p className="font-bold text-red-900">Error</p>
                        <p className="text-sm text-red-700">{message || 'Algo salió mal'}</p>
                    </div>
                </>
            )}
            <button
                onClick={() => {
                    setIsVisible(false);
                    onClose?.();
                }}
                className="ml-2 text-gray-400 hover:text-gray-600 flex-shrink-0"
            >
                ✕
            </button>
        </div>
    );
}
